interface Props {
  text: string;
  classNames?: string;
}

export default function LandingPageHeading(props: Props) {
  return (
    <h2
      className={`m-0 text-2xl lg:text-4xl leading-29px lg:leading-10 font-bold ${
        props.classNames ? props.classNames : ""
      }`}
    >
      {props.text}
    </h2>
  );
}
